import { APP_BOOTSTRAP_LISTENER, effect, inject, Provider } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InitialPopupComponent } from '@app/core/components/initial-popup/initial-popup.component';
import { ProfileState } from '@app/layout/common/profile/state/profile.state';

export const provideInitialPopup = (): Provider[] => {
  return [
    {
      provide: APP_BOOTSTRAP_LISTENER,
      multi: true,
      useFactory: () => {
        const profileState = inject(ProfileState);
        const matDialog: MatDialog = inject(MatDialog);
        let isShowing = false;

        effect(() => {
          const profile = profileState.profile();
          if (profile && !profile?.email && !isShowing) {
            matDialog.open(InitialPopupComponent);
            isShowing = true;
          } else {
            isShowing = false;
          }
        });

        return () => {};
      }
    }
  ];
};
